<div class="full-page login-banner w-100">
  <div class="full-container">
    <div>
      <img class="shared-login-banner d-lg-block d-none" alt="" draggable="false" src="assets/images/logos/NYJLogo.png" />
    </div>
    <div>
      <div class="container">
        <h2 class="text-secondary text-uppercase mb-2 my-lg-0">{{ 'activate.account.page.title' | translate }}</h2>
        <div class="text-black panel-text mlb-text font-size-14">
          {{ 'activate.account.page.description' | translate }}
        </div>
        <form [formGroup]="activateForm" (ngSubmit)="submit()">
          <div class="form-floating mb-3">
            <input
              [type]="isPasswordVisible ? 'text' : 'password'"
              formControlName="Password"
              class="form-control"
              id="floatingInput"
              placeholder="Insert new password here"
            />
            <label for="floatingInput">{{ 'activate.account.form.newpassword.label' | translate }}</label>
            <div
              *ngIf="activateForm.get('Password')?.hasError('pattern') && activateForm.get('Password')?.touched"
              class="alert-danger"
            >
              {{ 'activate.account.invalid.password' | translate }}
            </div>
            <div
              *ngIf="activateForm.get('Password')?.hasError('required') && activateForm.get('Password')?.touched"
              class="alert-danger"
            >
              {{ 'activate.account.password.required' | translate }}
            </div>
            <i class="material-icons text-info" (click)="isPasswordVisible = !isPasswordVisible">{{
              isPasswordVisible ? 'visibility' : 'visibility_off'
            }}</i>
          </div>
          <div class="form-floating">
            <input
              [type]="isConfirmPasswordVisible ? 'text' : 'password'"
              formControlName="ConfirmPassword"
              class="form-control"
              id="floatingPassword"
              placeholder="Insert password here"
            />
            <label for="floatingPassword">{{ 'activate.account.form.confirmpassword.label' | translate }}</label>
            <div
              *ngIf="activateForm.get('ConfirmPassword')?.hasError('required') && activateForm.get('ConfirmPassword')?.touched"
              class="alert-danger"
            >
              {{ 'activate.account.confirm.password.required' | translate }}
            </div>
            <i class="material-icons text-info" (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible">{{
              isConfirmPasswordVisible ? 'visibility' : 'visibility_off'
            }}</i>
          </div>
          <div *ngIf="activateForm?.hasError('passwordMismatch') && activateForm?.touched" class="alert-danger">
            {{ 'activate.account.password.mismatch' | translate }}
          </div>
          <div class="action-buttons mt-4">
            <button type="submit" class="btn btn-primary col-12">
              {{ 'activate.account.form.submit' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
